import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { MarketplaceScriptsHandlerProps } from './types';

const MarketplaceScriptHandler = ({ children }: MarketplaceScriptsHandlerProps) => {
  const [userInteractive, setUserInteractive] = useState(false);
  const router = useRouter();
  const userInteractHandler = () => {
    setUserInteractive(true);
  };

  useEffect(() => {
    if (!userInteractive) {
      window.addEventListener('mousedown', userInteractHandler);
      window.addEventListener('scroll', userInteractHandler);
      router.events.on('routeChangeStart', userInteractHandler);
    } else {
      window.removeEventListener('mousedown', userInteractHandler);
      window.removeEventListener('scroll', userInteractHandler);
      router.events.off('routeChangeComplete', userInteractHandler);
      return;
    }
  }, [userInteractive]);

  return typeof window !== 'undefined' && userInteractive ? children : null;
};

export default MarketplaceScriptHandler;
